module.exports = __webpack_public_path__ + "assets/img/simply-Brand_08.8ea08074.png";